import axios from "axios";
import { createContext, useContext, useEffect, useState } from "react";
import { Decryption } from "../lib/Decryption";
// import { SalesforceContext } from "./SF.CredantialsContext";
import { useOktaConfig } from "./CredentialsContext";
import { jwtDecode } from "jwt-decode";
import { DEV_PORTAL_ORIGIN, LOCAL_ORIGIN } from "../lib/hosts";

export const DomainSwitchContext = createContext(null);

export default function DomainSwitchProvider({ children }) {
  // const { setTokens } = useContext(SalesforceContext);
  const { setOktaConfig } = useOktaConfig();

  // Retrieve logo from localStorage initially, or set it to null if not found
  const [logo, setLogo] = useState(
    () => localStorage.getItem("Company Logo") || null
  );

  const testFunction = async () => {
    const { protocol, hostname, port } = window.location;
    let fullUrl = `${protocol}//${hostname}${port ? `:${port}` : ""}/`;
    // Send the company domain to the server
    let redirectUriLocal = null;
    if (fullUrl === `${LOCAL_ORIGIN}/`) {
      fullUrl = `${DEV_PORTAL_ORIGIN}/`;
      redirectUriLocal = `${LOCAL_ORIGIN}/login/callback`;
    }
    // console.log(redirectUriLocal);

    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}/companies?companyDomain=${fullUrl}`
      );

      const decodedToken = jwtDecode(String(res.data.data));


      const oktaClientID = Decryption(decodedToken._id);

      if (res.status === 200) {
        // localStorage.setItem("Token", JSON.stringify(res.data.data));
        // localStorage.setItem("CompanyName", data?.data.companyName);

        const newLogo = decodedToken.logo;
        // setLogo(newLogo); // Update state
        setLogo(newLogo);
        localStorage.setItem("Company Logo", newLogo); // Update localStorage
        setOktaConfig({
          clientId: oktaClientID,
          issuer: `https://${decodedToken.oktaDomain}/oauth2/default`,
          redirectUri: redirectUriLocal
            ? redirectUriLocal
            : fullUrl + "login/callback",
          scopes: ["openid", "profile", "email"],
          pkce: true,
          disableHttpsCheck: true,
        });
      }
    } catch (error) {
      // console.error("Error sending company domain:", error);
      return;
    }
  };

  useEffect(() => {
    testFunction();
  }, []); // Empty array ensures this runs once

  return (
    <DomainSwitchContext.Provider value={{ logo }}>
      {children}
    </DomainSwitchContext.Provider>
  );
}
